import { render, staticRenderFns } from "./UsersPrivilegeEmployees.vue?vue&type=template&id=1fd164d9&scoped=true&"
import script from "./UsersPrivilegeEmployees.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd164d9",
  null
  
)

export default component.exports